"use strict";
export function Collection(options = {}) {
  return {
    type: "Collection",
    requestGroup: options.requestGroup || "default"
  };
}
export function Entity(table, options = {}) {
  return {
    type: "Entity",
    table,
    requestGroup: options.requestGroup || "default"
  };
}
export function Related(options = {}) {
  return {
    type: "Related",
    requestGroup: options.requestGroup || "default"
  };
}
export function RangedCollection(options = {}) {
  return {
    type: "RangedCollection",
    requestGroup: options.requestGroup || "default"
  };
}
